module.exports = __webpack_public_path__ + "static/media/pdf.8ad9566d.svg";